import { render, staticRenderFns } from "./EditLimitForm.vue?vue&type=template&id=20fe9bc8&scoped=true&"
import script from "./EditLimitForm.vue?vue&type=script&lang=js&"
export * from "./EditLimitForm.vue?vue&type=script&lang=js&"
import style0 from "./EditLimitForm.vue?vue&type=style&index=0&id=20fe9bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fe9bc8",
  null
  
)

export default component.exports